import { gql, TypedDocumentNode } from '@apollo/client';
import type { Item } from '../models/Item';

export const GET_ITEMS_QUERY: TypedDocumentNode<{ items: Item[] }> = gql`
  query GetItems($filter: ItemFilterInput) {
    items(where: $filter, order: { name: ASC }) {
      id,
      name,
      unitType,
      isIngredient,
      description,
      orderNotes,
      standardShippingQuantity,
      minOrderQuantity,
      maxOrderQuantity,
      lowStock,
      outOfStock,
      totalQuantityOnHand,
      averageCostPerUnit,
      inventoryItems(where: { isArchived: { eq: false }}, order: { quantityOnHand: ASC }) {
        id,
        quantityOnHand,
        costPerUnit,
        quantityOrdered,
        isArchived
        lotNumber,
        surchargePerUnit,
        shippingCostPerUnit,
        surchargeOrDiscount,
        orderDetails,
        totalCostPerUnit,
        totalOrderedCost,
        purchaseOrderId,
        vendorId,
        vendor {
          id,
          name
        },
        purchaseOrderId,
        purchaseOrder {
          id,
          dateTimePurchased
        }
      }
    }
  }
`;

export const GET_ITEMS_FOR_PO_QUERY: TypedDocumentNode<{ items: Item[] }> = gql`
  query GetItems {
    items {
      id,
      name,
      unitType,
      isIngredient,
      description,
      orderNotes,
      standardShippingQuantity,
      minOrderQuantity,
      maxOrderQuantity,
      lowStock,
      outOfStock,
      totalQuantityOnHand,
      averageCostPerUnit
    }
  }
`;

export const GET_ITEM_BY_ID_QUERY: TypedDocumentNode<{ item: Item }, { id: number, inventoryItemsFilter?: {} }> = gql`
  query GetItemById($id: Int!, $inventoryItemsFilter: InventoryItemFilterInput) {
    item: itemById(id: $id) {
      id,
      name,
      unitType,
      isIngredient,
      description,
      orderNotes,
      standardShippingQuantity,
      minOrderQuantity,
      maxOrderQuantity,
      lowStock,
      outOfStock,
      totalQuantityOnHand,
      averageCostPerUnit,
      inventoryItems(where: $inventoryItemsFilter, order: { quantityOnHand: ASC }) {
        id,
        quantityOnHand,
        costPerUnit,
        quantityOrdered,
        isArchived,
        lotNumber,
        surchargePerUnit,
        shippingCostPerUnit,
        surchargeOrDiscount,
        orderDetails,
        totalCostPerUnit,
        totalOrderedCost,
        purchaseOrderId,
        vendorId,
        vendor {
          id,
          name
        },
        purchaseOrderId,
        purchaseOrder {
          id,
          dateTimePurchased
        }
      },
      productItems(order: { quantity: DESC }) {
        productId,
        product {
          name,
          totalItemQuantity
        },
        quantity,
        standardProductBatchQuantity
      }
    }
  }
`;
